import { render, staticRenderFns } from "./user-btn.vue?vue&type=template&id=a6688184&scoped=true&"
import script from "./user-btn.vue?vue&type=script&lang=ts&"
export * from "./user-btn.vue?vue&type=script&lang=ts&"
import style0 from "./user-btn.vue?vue&type=style&index=0&id=a6688184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6688184",
  null
  
)

export default component.exports